module.exports = __webpack_public_path__ + "static/media/david-troeger-9-xzy-ez-pahmi-unsplash.b203f9f2.jpg";